import Phaser from 'phaser'

const createChestAnims = (anims: Phaser.Animations.AnimationManager) => {
	anims.create({
		key: 'chest-open',
		frames: anims.generateFrameNames('mempool', { start: 0, end: 2, prefix: 'mempool ', suffix: '.aseprite' }),
		frameRate: 30
	})

	anims.create({
		key: 'chest-closed',
		frames: [{ key: 'mempool', frame: 'mempool 0.aseprite' }],
		frameRate: 30
	})

	anims.create({
		key: 'coin-rotate',
		frames: anims.generateFrameNames('coin', { start: 0, end: 2, prefix: 'coin ', suffix: '.aseprite' }),
		frameRate: 5,
		repeat: -1
	})

	anims.create({
		key: 'cube-rotate',
		frames: anims.generateFrameNames('cube', { start: 0, end: 7, prefix: 'cube ', suffix: '.aseprite' }),
		frameRate: 15,
		repeat: -1
	})
}

export {
	createChestAnims
}
